export const getAiAgentFlowUrl = () => {
  return location.host.startsWith('localhost:')
    ? 'http://localhost:8010'
    : `https://${location.host}/ai-agent-flow/`;
};

export const objectToQueryString = (params) => {
  const queryString = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return queryString ? `?${queryString}` : '';
};
